import { AppFeatureDims, AppFeatureKey } from '../entities/app-dim-app';

export const NACE_CODE_SCHEMAS = 'EU,NO,DK,SE,FI';

export const COUNTRY_APP_FEATURE_BY_ORG_NR_SCHEMA = {
  /* eslint-disable @typescript-eslint/naming-convention */
  NO: AppFeatureKey.norwegian_data,
  DK: AppFeatureKey.danish_data,
  SE: AppFeatureKey.swedish_data,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  // Finland was removed according to this task
  // https://linear.app/enin/issue/E-846/finland-tas-bort-som-mulighet-for-valg-av-land
  // FI: AppFeatureKey.finnish_data,
  /* eslint-enable */
};

export const ORG_NR_SCHEMA_BY_COUNTRY_APP_FEATURE = {
  [AppFeatureKey.norwegian_data]: 'NO',
  [AppFeatureKey.danish_data]: 'DK',
  [AppFeatureKey.swedish_data]: 'SE',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  // Finland was removed according to this task
  // https://linear.app/enin/issue/E-846/finland-tas-bort-som-mulighet-for-valg-av-land
  // [AppFeatureKey.finnish_data]: 'FI',
};

export const COUNTRY_FEATURES: AppFeatureKey[] = [
  AppFeatureKey.norwegian_data,
  AppFeatureKey.swedish_data,
  AppFeatureKey.danish_data,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  // Finland was removed according to this task
  // https://linear.app/enin/issue/E-846/finland-tas-bort-som-mulighet-for-valg-av-land
  // AppFeatureKey.finnish_data,
];

export const COMPANY_FLAG_FEATURES: AppFeatureKey[] = [
  AppFeatureKey.extended_company_flags,
  AppFeatureKey.experimental_company_flags,
  AppFeatureKey.indicator_flags,
];

export const PERSON_FLAG_FEATURES: AppFeatureKey[] = [
  AppFeatureKey.extended_person_flags,
  AppFeatureKey.experimental_person_flags,
  AppFeatureKey.indicator_flags,
];

export type AppFeatureDimKey = keyof AppFeatureDims['flags'];
